import React, { useState, useEffect} from "react";
import { makeStyles } from "@mui/styles";

import { SurchargeListToolbar, SurchargeTable } from "./components";


import { Alert } from "@mui/material";

import { Typography, Box } from '@mui/material';

import ListProvider from './ListProvider';
import { getSurchargeSettingsList } from "./surchargeUtils";



import { useSelector } from "react-redux";

import { BackButton } from "components";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    flexGrow: 1,
  },
  content: {
    marginTop: theme.spacing(3),
  },
  uiProgess: {
    position: "fixed",
    zIndex: "1000",
    height: "31px",
    width: "31px",
    left: "50%",
    top: "35%",
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(4),
    borderTop: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(4),
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(1),
  },
}));

const SurchargeList = (props) => {
  const classes = useStyles();
  


  const restaurant = useSelector(
    (state) => state.restaurant.selectedRestaurant
  );
  const [surcharges, setSurcharges] = useState([]);

  

  useEffect(() => {
    setSurcharges(getSurchargeSettingsList(restaurant));
  }, [restaurant]);





   if (!restaurant) {
      return (
        <main className={classes.content}>
          <BackButton to="/myrestaurant" label="My Restaurant" />
          <Alert severity="error">Please select a restaurant</Alert>{" "}
        </main>
      );
    }
   

    return (
      <div className={classes.root}>
        <BackButton to="/myrestaurant" label="My Restaurant" />
        <Box className={classes.header}>
          <Typography variant="h4" component="h1" gutterBottom>
            Surcharge Settings
          </Typography>
          <Typography variant="body1" className={classes.subtitle}>
            Manage surcharges for different order types, days, and special occasions
          </Typography>
        </Box>
         
        <ListProvider>
          <SurchargeListToolbar surcharges={surcharges}/>
          <div className={classes.content}>
            <SurchargeTable surcharges={surcharges} /> 
          </div>
        </ListProvider>
        
        <Box className={classes.footer}>
          <Typography variant="h6" gutterBottom color="primary">
            Important Information
          </Typography>
          <Typography variant="body2" paragraph>
            <strong>1.</strong> Surcharges apply to both online and in-store orders.
          </Typography>
          <Typography variant="body2" paragraph>
            <strong>2.</strong> If multiple surcharges are applicable on the same day, only the higher surcharge is applied.
          </Typography>
          <Typography variant="body2" paragraph>
            <strong>3.</strong> Changes to surcharge settings during active operations may impact ongoing transactions.
          </Typography>
          <Typography variant="body2" color="textSecondary">
            <strong>4.</strong> Leave order types empty to apply the surcharge to all order types.
          </Typography>
        </Box>
      </div>
    );
  // }
};

export default SurchargeList;
